import { freshAdviserStatisticsApi, freshAdviserListApi } from "@/libs/api.js";
// import { uleUrl, uleCdn, getCookie } from "@/libs/common";
// import bottomPop from "@/components/yzg/bottomPop.vue";
export default {
  name: "customer",
  data() {
    return {
      dateList: [
        {
          name: "今日",
          date: "1",
        },
        {
          name: "昨日",
          date: "0",
        },
        {
          name: "7天",
          date: "7",
        },
        {
          name: "30天",
          date: "30",
        },
      ],
      dateIndex: 0,
      type: 1,
      listTitle: "今日顾客浏览接龙统计",
      defaultAvatar: "https://pic.ulecdn.com/itempic_188x188.GIF",
      navList: [
        {
          name: "接龙",
          id: 1,
        },
        {
          name: "商品",
          id: 2,
        },
      ],
      customerInfo: {},
      listStatus: 0,
      list: [],
      show: false,
    };
  },

  mounted() {
    this.getFreshAdviserStatistics();
    this.getFreshAdviserList();
  },
  methods: {
    handleChangeNav(item) {
      this.currentId = item.id;
      this.type = item.id;
      this.listTitle = {
        1: "今日顾客浏览接龙统计",
        2: "今日顾客浏览商品统计",
      }[this.type];
      this.getFreshAdviserStatistics();
      this.getFreshAdviserList();
    },
    handleChaneDate(index) {
      this.dateIndex = index;
      this.getFreshAdviserStatistics();
      // this.getFreshAdviserList();
    },
    // 店铺数据
    getFreshAdviserStatistics() {
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "加载中...",
      });
      let query = {
        type: this.dateList[this.dateIndex].date,
        freshType: this.type,
        clientCallType: "H5",
      };
      freshAdviserStatisticsApi(query).then((res) => {
        this.$toast.clear();
        if (res.returnCode == "0000") {
          this.customerInfo = res.data;
        }
      });
    },
    // 店铺列表
    getFreshAdviserList() {
      console.log("type", this.type);
      let query = {
        type: 1,
        freshType: this.type,
        orderType: 1,
        clientCallType: "H5",
        pageIndex: 1,
        pageSize: 10,
      };
      freshAdviserListApi(query).then((res) => {
        if (res.returnCode == "0000") {
          if (res.data && res.data.freshAdviserListRess) {
            this.list = res.data.freshAdviserListRess || [];
            if (this.list.length > 0) {
              this.listStatus = 1;
            } else {
              this.listStatus = 2;
            }
          } else {
            this.listStatus = 2;
          }
        } else {
          this.listStatus = 2;
        }
      });
    },
    handleBackApp() {
      location.href = "ulemobile://ulePopView";
    },
  },
};
